<template>
    <div>
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 20px"
        >
            <form-lookup
                style="min-width: 262px; margin-right: 15px"
                v-model="selectRoom.roomId"
                :options.sync="selectRoom.roomList"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room />
            </form-lookup>
            <Select
                style="width: 100px; margin-right: 20px"
                v-model="filter.feeType"
                placeholder="费用类型"
                @on-change="search"
                clearable
            >
                <Option
                    v-for="item in feeTypeList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <Select
                style="width: 100px; margin-right: 20px"
                v-model="filter.payType"
                placeholder="交易方式"
                @on-change="search"
                clearable
            >
                <Option
                    v-for="item in payTypeList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.keyword"
                    placeholder="请输入客户姓名,手机号或单位名称"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <span style="margin-right: 10px">
                <span>
                    总收入：<span class="price" style="color: #ff3739">{{
                        inAmount | currency
                    }}</span>
                </span>
                <span>
                    总支出：<span class="price" style="color: #70b603">{{
                        outAmount | currency
                    }}</span>
                </span>
                <span>
                    结余：<span class="price" style="color: #333333">{{
                        leftAmount | currency
                    }}</span>
                </span>
            </span>
            <Button
                v-if="$can('view')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                :loading="loadingExport"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:amount="{ row }">
                <tag-status
                    :text="row.amount"
                    :color="row.flowType === '1' ? '#FF3739' : '#70B603'"
                />
            </template>
            <template v-slot:includeService="{ row }">
                <tag-status
                    :text="row.includeService"
                    :color="row.flowType === '1' ? '#FF3739' : '#70B603'"
                />
            </template>
        </Table>
        <div class="card-bottom">
            <table-pager
                :total="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.pageNo"
                @change="fetch"
            >
            </table-pager>
        </div>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import Dict from '_u/dict'
import { currency, ymdL } from '_u/helper'

import mList from '_v/common/m-list'
import SelectRoom from '_vc/select-room'
import TagStatus from '_vc/tag-status'
import FilterDateRange from '_v/components/filter/filter-date-range'

import { financesFlowList, totalFeeStatistic } from '@/api/finance'

export default {
    name: 'f-account-list',
    mixins: [mList],
    components: {
        SelectRoom,
        TagStatus,
        FilterDateRange,
    },
    data() {
        return {
            loadingExport: false,
            page: {
                total: 0,
                list: [],
            },
            inAmount: 0,
            outAmount: 0,
            leftAmount: 0,
            loading: false,
            mtHeight: 360,
            dict: {
                payType: Dict.NULL,
                feeType: Dict.NULL,
            },
        }
    },
    computed: {
        ...mapCache({
            filter: 'financeAccount',
            selectRoom: 'financeAccountSelectRoom',
        }),
        columns() {
            return [
                {
                    type: 'index',
                    width: 80,
                    title: '序号',
                    align: 'center',
                },
                {
                    title: '房源名称',
                    key: 'houseName',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true,
                },
                {
                    title: '客户姓名',
                    key: 'cusName',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    title: '客户手机号',
                    key: 'cusMobile',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'comName',
                    title: '单位名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    title: '费用类型',
                    key: 'feeTypeText',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '金额(元)',
                    key: 'amount',
                    align: 'right',
                    minWidth: 160,
                    slot: 'amount',
                },
                {
                    key: 'includeService',
                    title: '含手续费',
                    align: 'right',
                    width: 160,
                    slot: 'includeService',
                },
                {
                    title: '交易方式',
                    key: 'payTypeText',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '到账日期',
                    key: 'clinchTime',
                    align: 'center',
                    minWidth: 150,
                },
                {
                    title: '记账时间',
                    key: 'createTimeText',
                    align: 'center',
                    minWidth: 150,
                },
            ]
        },

        payTypeList() {
            return this.dict.payType.toList()
        },
        feeTypeList() {
            return this.dict.feeType.toList()
        },
    },
    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                financesFlowList(this.filter),
                totalFeeStatistic(this.filter),
                Dict.get(['pay_type', 'fee_type']),
            ])
                .then((args) => {
                    var [view, data, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.inAmount =
                        data.data.list.find((v) => v.flowType === '1').amount /
                        100
                    this.outAmount = -(
                        data.data.list.find((v) => v.flowType === '2').amount /
                        100
                    )
                    this.leftAmount = this.inAmount + this.outAmount

                    this.page.list = this.normalizePageData(view.data)
                    this.page.total = parseInt(view.data.page.totalCount)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
        normalizePageData(data) {
            var list = data.page.list
            list.forEach((v) => {
                v.clinchTime = ymdL(v.clinchTime)
                v.createTimeText = ymdL(v.createTime)

                v.amount = currency(
                    (v.flowType === '1' ? v.amount : -v.amount) / 100
                )
                v.includeService = currency(
                    (v.flowType === '1'
                        ? v.includeService
                        : -v.includeService) / 100
                )
                v.serviceFee = currency(v.serviceFee / 100 || 0)
                v.feeTypeText = this.dict.feeType.val(v.feeType)
                v.payTypeText = this.dict.payType.val(v.payType)
            })

            return list
        },
        // 导出Excel
        onClickExport() {
            this.loadingExport = true
            financesFlowList(
                Object.assign({}, this.filter, {
                    pageNo: 1,
                    pageSize: 999999,
                })
            )
                .then((res) => {
                    this.$refs.mt.exportToExcel({
                        rows: this.normalizePageData(res.data),
                    })
                })
                .finally(() => (this.loadingExport = false))
        },
    },
    watch: {},
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    created() {
        this.fetch()
    },
}
</script>
<style lang="less" scoped>
.price {
    font-size: 16px;
    padding-right: 10px;
}
</style>
